import React from 'react';

function Icon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24">
      <polygon id="" fill="#9EADE5" fillRule="nonzero" points="12 18.6611884 4.55769231 23 6.54807692 14.8508217 0 9.37168142 8.625 8.64854614 12 1 15.375 8.64854614 24 9.37168142 17.4807692 14.8508217 19.4423077 23" />
    </svg>
  );
}

export default Icon;
